var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_50_Kids_Icons-48",
    "data-name": "50_Kids_Icons-48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1667",
    "data-name": "Path 1667",
    d: "M0,40A40,40,0,1,1,40,80,40,40,0,0,1,0,40Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1664",
    "data-name": "Path 1664",
    d: "M0,40A40,40,0,1,1,40,80,40,40,0,0,1,0,40Z",
    fill: "#3d2a3d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5082",
    "data-name": "Group 5082"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5063",
    "data-name": "Group 5063",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1665",
    "data-name": "Path 1665",
    d: "M152.947,246.493c1.025,2.428.467,4.787-1.247,5.27s-3.933-1.093-4.958-3.521-.467-4.787,1.247-5.27S151.922,244.065,152.947,246.493Z",
    transform: "translate(-123.38 -204.934)",
    fill: "#e68c6f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1666",
    "data-name": "Path 1666",
    d: "M320,246.492c-1.025,2.428-.467,4.787,1.247,5.27s3.933-1.093,4.958-3.521.467-4.787-1.247-5.27S321.025,244.065,320,246.492Z",
    transform: "translate(-269.567 -204.934)",
    fill: "#e68c6f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5064",
    "data-name": "Group 5064",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1668",
    "data-name": "Path 1668",
    d: "M128.4,412.258l-.008-.132c0-8-2.995-15.753-6.652-17.229l-15.575-6.275a20.633,20.633,0,0,0-13.3-.017l-15.8,6.312c-3.66,1.465-6.655,9.208-6.655,17.209l-.008.132Z",
    transform: "translate(-59.397 -326.964)",
    fill: "#e68c6f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5065",
    "data-name": "Group 5065",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1670",
    "data-name": "Path 1670",
    d: "M226.979,277.007a6.219,6.219,0,0,1-6.219,6.219h-.754a6.219,6.219,0,0,1-6.219-6.219V260.989a6.219,6.219,0,0,1,6.219-6.219h.754a6.219,6.219,0,0,1,6.219,6.219Z",
    transform: "translate(-180.384 -214.962)",
    fill: "#e68c6f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5067",
    "data-name": "Group 5067",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5066",
    "data-name": "Group 5066",
    transform: "translate(26.617 18.107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1672",
    "data-name": "Path 1672",
    d: "M197.113,143.36a10.422,10.422,0,0,1-10.423,10.422h-5.923a10.422,10.422,0,0,1-10.422-10.422V126.306a10.422,10.422,0,0,1,10.422-10.422h5.923a10.422,10.422,0,0,1,10.423,10.422Z",
    transform: "translate(-170.346 -115.884)",
    fill: "#f5b29c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5068",
    "data-name": "Group 5068",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_531",
    "data-name": "Ellipse 531",
    cx: 1.548,
    cy: 1.548,
    r: 1.548,
    transform: "translate(33.321 40.012)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_532",
    "data-name": "Ellipse 532",
    cx: 1.548,
    cy: 1.548,
    r: 1.548,
    transform: "translate(43.584 40.012)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5069",
    "data-name": "Group 5069",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1675",
    "data-name": "Path 1675",
    d: "M244.43,279.542a2.384,2.384,0,0,1-4.653.538,2.526,2.526,0,0,0-.114.71,2.553,2.553,0,1,0,5.105,0A2.516,2.516,0,0,0,244.43,279.542Z",
    transform: "translate(-202.216 -235.864)",
    fill: "#f59576"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5070",
    "data-name": "Group 5070",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1677",
    "data-name": "Path 1677",
    d: "M128.39,425.067c0-8-3-15.753-6.652-17.229l-12.384-4.989a10.937,10.937,0,0,1-19.889.053l-12.4,4.956c-3.66,1.465-6.655,9.208-6.655,17.209l-.008.132h58Z",
    transform: "translate(-59.398 -339.904)",
    fill: "#78bede"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5075",
    "data-name": "Group 5075",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5071",
    "data-name": "Group 5071",
    transform: "translate(24.818 15.741)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1679",
    "data-name": "Path 1679",
    d: "M161.224,123.42l.609-5.347a5.61,5.61,0,0,1,5.574-4.975h13.215a5.61,5.61,0,0,1,5.574,4.974l.61,5.348h1.534a18.869,18.869,0,0,0,.857-5.65c0-9.405-6.8-17.029-15.182-17.029s-15.182,7.624-15.182,17.029a18.864,18.864,0,0,0,.857,5.65Z",
    transform: "translate(-158.833 -100.742)",
    fill: "#a14b2a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5074",
    "data-name": "Group 5074",
    transform: "translate(24.754 23.036)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5072",
    "data-name": "Group 5072"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1680",
    "data-name": "Path 1680",
    d: "M158.427,166.012l2.367-.073L162.3,147.43l-3.074,6.008Z",
    transform: "translate(-158.427 -147.43)",
    fill: "#a14b2a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5073",
    "data-name": "Group 5073",
    transform: "translate(26.614)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1681",
    "data-name": "Path 1681",
    d: "M332.632,166.012l-2.367-.073-1.511-18.508,3.074,6.008Z",
    transform: "translate(-328.754 -147.43)",
    fill: "#a14b2a"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5076",
    "data-name": "Group 5076",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1683",
    "data-name": "Path 1683",
    d: "M190.05,107.535c8.57,0,15.659-4.36,16.847-10.033a20.9,20.9,0,0,0-12.841-4.029c-8.57,0-15.659,4.36-16.847,10.033A20.906,20.906,0,0,0,190.05,107.535Z",
    transform: "translate(-149.52 -78.867)",
    fill: "#a14b2a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5079",
    "data-name": "Group 5079",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5077",
    "data-name": "Group 5077",
    transform: "translate(30.854 36.48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1685",
    "data-name": "Path 1685",
    d: "M198.31,235.912a4.644,4.644,0,0,1,3.443-1.435.5.5,0,0,0,0-1.005A5.654,5.654,0,0,0,197.6,235.2c-.435.479.274,1.192.711.711Z",
    transform: "translate(-197.463 -233.472)",
    fill: "#a14b2a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5078",
    "data-name": "Group 5078",
    transform: "translate(43.226 36.48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1686",
    "data-name": "Path 1686",
    d: "M281.284,235.2a5.654,5.654,0,0,0-4.154-1.729.5.5,0,0,0,0,1.005,4.643,4.643,0,0,1,3.443,1.435c.437.48,1.146-.233.711-.711Z",
    transform: "translate(-276.645 -233.472)",
    fill: "#a14b2a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5081",
    "data-name": "Group 5081",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5080",
    "data-name": "Group 5080",
    transform: "translate(33.941 47.852)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1688",
    "data-name": "Path 1688",
    d: "M226.959,306.564c-1.751,2.825-6.743,2.833-8.5.016-.448-.714-1.58-.056-1.13.664,2.288,3.661,8.491,3.65,10.768-.02.446-.72-.689-1.374-1.133-.66Z",
    transform: "translate(-217.221 -306.255)",
    fill: "#a91935"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar7);
export default __webpack_public_path__ + "static/media/avatar7.57056c12b360bc67649c6b57d2411a1e.svg";
export { ForwardRef as ReactComponent };